// M.js

import React from 'react';
import './M.css';

const M = () => {
  return (
    <div className="m-container">
      <p className="m-text">Mezzanine</p>
      <p className="under-construction">Under Construction - Check back later!</p>
      <p className="additional-info">We're still working on this page. Stay tuned for updates!</p>
    </div>
  );
}

export default M;
